import { useCallback } from 'react';
import { GApageViewGenre } from '@/helpers/events-ga/page-views';
import { ICpageViewGenre } from '@/helpers/events-intercom/page-views';
import useSendGAEvent from '@/hooks/ga/useSendGAEvent';
import useSendIntercomEvent from '@/hooks/intercom/useSendIntercomEvent';

const useGenreEvents = ({
  genreId,
  genreTitle,
  parentId,
  parentTitle,
  isViewingNewShows,
  shouldSend = false
} = {}) => {
  const shouldSendPageViewEvents = !!shouldSend && !!genreId && !!genreTitle;

  // Page view event: GA
  useSendGAEvent({
    createEvent: useCallback(() => GApageViewGenre({
      genreId,
      genreTitle,
      parentGenreId: parentId,
      parentGenreTitle: parentTitle,
      isNew: isViewingNewShows
    }), [genreId, genreTitle, parentId, parentTitle, isViewingNewShows]),
    shouldSend: shouldSendPageViewEvents
  });

  // Page view event: Intercom
  useSendIntercomEvent({
    createEvent: useCallback(() => ICpageViewGenre({
      genreId,
      genreTitle,
      parentGenreId: parentId,
      parentGenreTitle: parentTitle,
      isNew: isViewingNewShows
    }), [genreId, genreTitle, parentId, parentTitle, isViewingNewShows]),
    shouldSend: shouldSendPageViewEvents
  });
};

export default useGenreEvents;